import { motion } from 'framer-motion';
import { useTranslation } from '@/i18n';
import { useReducedMotion } from '@/hooks/useReducedMotion';

export function GreetingText() {
  const { t } = useTranslation();
  const reduced = useReducedMotion();

  return (
    <motion.div
      className="text-center px-6"
      initial={reduced ? undefined : { opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
    >
      <h1 className="font-display text-2xl md:text-3xl lg:text-4xl text-white tracking-wide leading-tight">
        {t('landing.greeting')}
      </h1>
      <p className="mt-4 text-base md:text-lg text-white/70 max-w-xl mx-auto font-body leading-relaxed">
        {t('landing.subtitle')}
      </p>
    </motion.div>
  );
}
